










import Vue from 'vue'
import SpeciesRiscoTableHeader from '@/UI/Batch/Species/SpeciesRiscoTableHeader.vue'
import SpeciesRiscoTableRow from '@/UI/Batch/Species/SpeciesRiscoTableRow.vue'
import { SpeciesDto } from '@/Application/Batch/Species/SpeciesDto'

export default Vue.extend({
  name: 'SpeciesRiscoTable',
  components: {
    SpeciesRiscoTableRow,
    SpeciesRiscoTableHeader
  },
  props: {
    species: {
      type: Array as () => SpeciesDto[],
      required: true
    },
    volumenUnit: {
      type: String,
      required: true
    }
  }
})
